import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware } from 'connected-react-router/immutable';
import createSagaMiddleware from 'redux-saga';
import { createBrowserHistory } from 'history';

import makeRootReducer from 'reducers';
import rootSaga from 'sagas';

const history = createBrowserHistory();
const routeMiddleware = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();

const middlewares = [routeMiddleware, sagaMiddleware];
let composeEnhancers = compose;
if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    trace: true,
    traceLimit: 25,
  });
}

export default function configureStore(initialState) {
  const rootReducer = makeRootReducer(history);
  let store;
  if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_CUSTOM_NODE_ENV !== 'staging') {
    store = createStore(rootReducer, initialState, compose(applyMiddleware(...middlewares)));
  } else {
    store = createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...middlewares)));
  }

  sagaMiddleware.run(rootSaga);

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers/index', () => {
      const nextRootReducer = require('../reducers/index');
      store.replaceReducer(nextRootReducer);
    });
  }
  return store;
}

export { history };
